export function initPossibilitiesBlocks() {
	const blocks = document.querySelectorAll('[data-possibilities]');
	if (!blocks.length) {
		return;
	}

	blocks.forEach((block) => {
		initPossibilitiesTabs(block);
	});
}

function initPossibilitiesTabs(block) {
	const tabs = Array.from(block.querySelectorAll('[data-tab-target]'));
	const panels = Array.from(block.querySelectorAll('.possibilities-block__panel'));
	if (!tabs.length || !panels.length) {
		return;
	}

	const activate = (targetPanelId) => {
		tabs.forEach((tab) => {
			const isActive = tab.getAttribute('data-tab-target') === targetPanelId;
			tab.classList.toggle('is-active', isActive);
			tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
		});

		panels.forEach((panel) => {
			const isActive = panel.id === targetPanelId;
			panel.classList.toggle('is-active', isActive);
			panel.hidden = !isActive;
		});
	};

	tabs.forEach((tab) => {
		tab.addEventListener('click', () => {
			const targetPanelId = tab.getAttribute('data-tab-target') || '';
			if (targetPanelId !== '') {
				activate(targetPanelId);
			}
		});
	});

	const firstPanelId = tabs[0].getAttribute('data-tab-target') || '';
	if (firstPanelId !== '') {
		activate(firstPanelId);
	}
}
